import { useMantineTheme, type MantineSize } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useIsThemeSize = (size: MantineSize) => {
  const theme = useMantineTheme();
  return !!useMediaQuery('(max-width: ' + theme.breakpoints[size] + ')');
};
export const useIsXs = () => {
  return useIsThemeSize('xs');
};
export const useIsSm = () => {
  return useIsThemeSize('sm');
};
export const useIsMd = () => {
  return useIsThemeSize('md');
};
export const useIsLg = () => {
  return useIsThemeSize('lg');
};
export const useIsXl = () => {
  return useIsThemeSize('xl');
};
